import { PhoneHoursScheduleRule } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';

/**
 * Returns a deterministic representation of phone hours for deep equality checks.
 *
 * - Sorts schedules by `scheduleId`
 * - Sorts nested `rules` (when present) to avoid order-only diffs
 * - Preserves the original input array/object references by operating on copies
 */
export const normalizePhoneHours = (phoneHours: PhoneHoursScheduleRule[]): PhoneHoursScheduleRule[] => {
  return phoneHours
    .slice()
    .sort((a, b) => a.scheduleId.localeCompare(b.scheduleId))
    .map((schedule) => ({
      ...schedule,
      // Normalize nested rule ordering so semantic equivalents compare equal.
      ...(schedule.rules && {
        rules: [...schedule.rules].sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))),
      }),
    }));
};

/**
 * Removes duplicate schedules by `scheduleId`, keeping the first occurrence.
 *
 * This helps compare form state against initial values when the source data
 * can contain repeated schedule entries.
 */
export const dedupeByScheduleId = (items: PhoneHoursScheduleRule[]): PhoneHoursScheduleRule[] => {
  const seen = new Set<string>();

  return items.filter((item) => {
    if (seen.has(item.scheduleId)) return false;
    seen.add(item.scheduleId);
    return true;
  });
};
